import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMediaQueryMatchesOnMobile } from '@yonderland/andes-react';
import { Button, Text, TextSize, Box, Group, GroupAlign, GroupVerticalAlign, TextAlign } from '@as/cotopaxi';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { useAemConfig } from '@as-react/common-components';
const CompareEmptyPage = () => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const { root } = useAemConfig();
    const isMobile = useMediaQueryMatchesOnMobile();
    return (_jsx(Box, { mobile: {
            spacing: {
                paddingTop: 7,
                paddingBottom: 7,
            },
        }, tablet: {
            spacing: {
                paddingTop: 16,
                paddingBottom: 16,
            },
        }, children: _jsxs(Group, { column: true, align: GroupAlign.SPACE_AROUND, valign: !isMobile && GroupVerticalAlign.CENTER, children: [_jsx(Text, { size: TextSize.LARGE, inline: true, align: TextAlign.CENTER, children: t('compare.empty.nothing.added') }), _jsx(Box, { mobile: {
                        spacing: {
                            marginTop: 2,
                        },
                    }, children: _jsx(Button, { fill: isMobile, href: `${root}lister.html`, text: t('compare.empty.add.products') }) })] }) }));
};
export { CompareEmptyPage };
